import { s32 } from '@ardoq/design-tokens';
import { SmallGhostButton } from '@ardoq/button';
import { noop } from 'lodash';
import { getDateFromYearMonthAndDay } from '../utils';
import { FlexBox } from '@ardoq/layout';
import { WithPopoverPlacement, WithPopover } from '@ardoq/popovers';

type DayGridRowProps = {
  readonly year: number;
  readonly month: number;
  data: (number | undefined)[];
  activeDay?: number;
  onSelectDay?: (day: number) => void;
  isDayDisabled?: (date: Date) => boolean;
  disabledDayPopoverText?: string;
};

export const DayGridRow = ({
  year,
  month,
  data,
  activeDay,
  onSelectDay = noop,
  isDayDisabled,
  disabledDayPopoverText,
}: DayGridRowProps) => (
  <FlexBox gap="xsmall">
    {data.map((day, i) => {
      if (day) {
        const isDisabled = Boolean(
          isDayDisabled?.(getDateFromYearMonthAndDay({ year, month, day }))
        );
        const DayButton = (
          <SmallGhostButton
            style={{
              width: s32,
              maxWidth: s32,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            key={i}
            isActive={day === activeDay}
            onClick={() => onSelectDay(day)}
            isDisabled={isDisabled}
          >
            {day}
          </SmallGhostButton>
        );
        if (isDisabled) {
          return (
            <WithPopover
              key={i}
              content={disabledDayPopoverText}
              preferredPlacement={WithPopoverPlacement.TOP}
            >
              <div style={{ width: s32 }}>{DayButton}</div>
            </WithPopover>
          );
        }
        return DayButton;
      }
      return <div style={{ width: s32 }} key={i} />;
    })}
  </FlexBox>
);
